import { useMemo } from "react";

import { generateBranchUrl } from "utils/urls";
import { Module } from "types/generated";
import TableCellSimple from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellBranch from "ds/components/Table/Row/CellBranch";

import { ModulesSuggestions } from "../../FiltersLayout/constants";
import useModulesAnalytics from "../../useModulesAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const ModulesTableBranchCell = ({ item: module, ...cellProps }: TableSimpleCellProps<Module>) => {
  const trackAnalytics = useModulesAnalytics();

  const branchFilterAction = useCellFilterAction({
    filterName: ModulesSuggestions.Branch,
    filterValue: module.branch,
  });

  const actions = useMemo(() => [branchFilterAction], [branchFilterAction]);

  return (
    <TableCellSimple {...cellProps} actions={actions}>
      {!module.apiHost && <TableCellEmpty />}

      {module.apiHost && (
        <TableCellBranch
          href={generateBranchUrl({
            apiHost: module.apiHost!,
            namespace: module.namespace,
            repository: module.repository,
            repositoryURL: module.repositoryURL || "",
            provider: module.provider,
            branch: module.branch,
          })}
          onPress={() => trackAnalytics("Branch link clicked")}
        >
          {module.branch}
        </TableCellBranch>
      )}
    </TableCellSimple>
  );
};

export default ModulesTableBranchCell;
